import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'bg',
  months: [
    'януари',
    'февруари',
    'март',
    'април',
    'май',
    'юни',
    'юли',
    'август',
    'септември',
    'октомври',
    'ноември',
    'декември',
  ],
  monthsShort: ['яну', 'фев', 'март', 'апр', 'май', 'юни', 'юли', 'авг', 'сеп', 'окт', 'ное', 'дек'],
  weekdays: ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота'],
  weekdaysMin: ['н', 'п', 'в', 'с', 'ч', 'п', 'с'],
  weekdaysShort: ['нед', 'пон', 'вт', 'ср', 'четв', 'пет', 'съб'],
  formats: {
    LT: 'H:mm',
    LTS: 'H:mm:ss',
    lt: 'H:mm',
    lts: 'H:mm:ss',
    L: 'D.MM.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, H:mm',
    'LLL-Y': 'D MMMM, H:mm',
    LLLL: 'dddd, D MMMM YYYY, H:mm',
    'LLLL-Y': 'dddd, D MMMM, H:mm',
    l: 'D.MM.YYYY',
    'l-Y': 'D.MM',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, H:mm',
    'lll-Y': 'D MMM, H:mm',
    llll: 'ddd, D MMM YYYY, H:mm',
    'llll-Y': 'ddd, D MMM, H:mm',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'H:mm ([Гринуич]Z)',
    'LLL+to': 'D MMMM YYYY, H:mm ([Гринуич]Z)',
  },
  past: {
    y: { one: 'преди %s г.', other: 'преди %s г.' },
    M: { one: 'преди %s м.', other: 'преди %s м.' },
    w: { one: 'преди %s сед.', other: 'преди %s сед.' },
    d: { one: 'преди %s ден', other: 'преди %s дни' },
    h: { one: 'преди %s ч', other: 'преди %s ч' },
    m: { one: 'преди %s мин', other: 'преди %s мин' },
    s: { one: 'преди %s сек', other: 'преди %s сек' },
  },
  future: {
    y: { one: 'след %s г.', other: 'след %s г.' },
    M: { one: 'след %s м.', other: 'след %s м.' },
    w: { one: 'след %s сед.', other: 'след %s сед.' },
    d: { one: 'след %s ден', other: 'след %s дни' },
    h: { one: 'след %s ч', other: 'след %s ч' },
    m: { one: 'след %s мин', other: 'след %s мин' },
    s: { one: 'след %s сек', other: 'след %s сек' },
  },
  pastLong: {
    y: { one: 'преди %s година', other: 'преди %s години' },
    M: { one: 'преди %s месец', other: 'преди %s месеца' },
    w: { one: 'преди %s седмица', other: 'преди %s седмици' },
    d: { one: 'преди %s ден', other: 'преди %s дни' },
    h: { one: 'преди %s час', other: 'преди %s часа' },
    m: { one: 'преди %s минута', other: 'преди %s минути' },
    s: { one: 'преди %s секунда', other: 'преди %s секунди' },
  },
  futureLong: {
    y: { one: 'след %s година', other: 'след %s години' },
    M: { one: 'след %s месец', other: 'след %s месеца' },
    w: { one: 'след %s седмица', other: 'след %s седмици' },
    d: { one: 'след %s ден', other: 'след %s дни' },
    h: { one: 'след %s час', other: 'след %s часа' },
    m: { one: 'след %s минута', other: 'след %s минути' },
    s: { one: 'след %s секунда', other: 'след %s секунди' },
  },
  abbr: {
    y: { one: '%s г.', other: '%s г.' },
    M: { one: '%s мес.', other: '%s мес.' },
    w: { one: '%s сед.', other: '%s сед.' },
    d: { one: '%s ден', other: '%s дни' },
    h: { one: '%s час', other: '%s часа' },
    m: { one: '%s мин.', other: '%s мин.' },
    s: { one: '%s сек.', other: '%s сек.' },
  },
  full: {
    y: { one: '%s година', other: '%s години' },
    M: { one: '%s месец', other: '%s месеца' },
    w: { one: '%s седмица', other: '%s седмици' },
    d: { one: '%s ден', other: '%s дни' },
    h: { one: '%s час', other: '%s часа' },
    m: { one: '%s минута', other: '%s минути' },
    s: { one: '%s секунда', other: '%s секунди' },
  },
  justNow: 'в момента',
  yesterday: 'вчера',
  today: 'днес',
  tomorrow: 'утре',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D.MM', end: 'D.MM.YYYY' },
    dl: { start: 'D.MM', end: 'D.MM' },
    y: { start: 'D.MM.YYYY', end: 'D.MM.YYYY' },
    'y-1': { start: 'D.MM', end: 'D.MM.YYYY' },
    m: { start: 'D.MM', end: 'D.MM' },
    'm-1': { start: 'D.MM', end: 'D.MM.YYYY' },
    d: { start: 'D.MM', end: 'D.MM' },
    Y: { start: 'ddd, D.MM.YYYY', end: 'ddd, D.MM.YYYY' },
    'Y-1': { start: 'ddd, D.MM', end: 'ddd, D.MM.YYYY' },
    M: { start: 'ddd, D.MM', end: 'ddd, D.MM' },
    D: { start: 'ddd, D.MM', end: 'ddd, D.MM' },
    yt: { start: 'D.MM.YYYY, HH:mm', end: 'D.MM.YYYY, HH:mm' },
    mt: { start: 'D.MM, HH:mm', end: 'D.MM, HH:mm' },
    dt: { start: 'D.MM, HH:mm', end: 'D.MM, HH:mm' },
    t: { start: 'H:mm', end: 'H:mm' },
    'yt+to': { start: 'D.MM.YYYY, HH:mm', end: 'D.MM.YYYY, HH:mm ([Гринуич]Z)' },
    'mt+to': { start: 'D.MM, HH:mm', end: 'D.MM, HH:mm ([Гринуич]Z)' },
    'dt+to': { start: 'D.MM, HH:mm', end: 'D.MM, HH:mm ([Гринуич]Z)' },
    't+to': { start: 'H:mm', end: 'H:mm ([Гринуич]Z)' },
  },
};
const localeName: LocaleName = 'bg';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => {
    const last2Digits = n % 100;
    if (last2Digits > 10 && last2Digits < 20) {
      return `${n}-ти`;
    }

    const lastDigit = n % 10;
    if (lastDigit === 1) {
      return `${n}-ви`;
    } else if (lastDigit === 2) {
      return `${n}-ри`;
    } else if (lastDigit === 7 || lastDigit === 8) {
      return `${n}-ми`;
    }

    return `${n}-ти`;
  },
  meridiem: (): string => '',
};
